import React from 'react'
import './Hero.css';

function Hero() {
  return (
    <>
    <div className="hero">
    <h1>
        To-Do List 
    </h1>
    </div>
    <div className="txt">
    <p>Lets plan our tasks beforehand for a productive day.</p>
    </div>
    </>
  )
}

export default Hero